import script from "./Annual.vue?vue&type=script&lang=ts&setup=true"
export * from "./Annual.vue?vue&type=script&lang=ts&setup=true"

import "./Annual.vue?vue&type=style&index=0&id=59fad244&lang=scss&scoped=true"

import exportComponent from "D:\\project\\new_fd_yun\\website-dev-En\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59fad244"]])

export default __exports__